import {Product} from '@/model/product';
import {getSelectedProduct} from '@/util/product.util';
import {FormularData} from '@/model/form-data';
import {Delivery, DeliveryResult, FormResult} from '@/model/form-result';
import {DeliveryMethod, DeliveryMethods} from '@/model/delivery-method';
import {replaceCommas} from '@/util/number.util';

export class DeliveryResultService {
  public static calculateDeliveryResult(
    formData: FormularData,
    products: Product[],
    deliveryMethods: DeliveryMethods,
    duration: number | null
  ): FormResult {
    const product = getSelectedProduct(formData, products);
    const volume = Math.max(Math.ceil(4 * parseFloat(replaceCommas(formData.volume))) / 4, 0.5);
    const result: DeliveryResult = this.calculateFullResult(volume, product, duration, deliveryMethods);
    return {
      productTitle: product.product,
      productDescription: product.description,
      result
    }
  }

  private static calculateProductPriceOnly(volume: number, product: Product) {
    return product.pricePerUnit * volume;
  }

  private static calculateDeliveryOnly(volume: number, product: Product, duration: number, deliveryMethods: DeliveryMethods): Delivery {
    if (volume > product.maxPKWAmount) {
      return {
        deliveryDescription: deliveryMethods.lkw.description,
        deliveryPrice: this.getDeliveryPrice(duration, deliveryMethods.lkw)
      }
    } else {
      return {
        deliveryDescription: deliveryMethods.pkw.description,
        deliveryPrice: this.getDeliveryPrice(duration, deliveryMethods.pkw)
      }
    }
  }

  public static calculateFullResult(volume: number, product: Product, duration: number | null, deliveryMethods: DeliveryMethods): DeliveryResult {
    if (!isNaN(volume) && duration != null) {
      const delivery = this.calculateDeliveryOnly(volume, product, duration, deliveryMethods);
      const productPrice = this.calculateProductPriceOnly(volume, product);
      return {
        ...delivery,
        productPrice,
        volume
      };
    } else if (!isNaN(volume)) {
      const productPrice = this.calculateProductPriceOnly(volume, product);
      return {
        volume,
        productPrice
      };
    } else if (duration != null) {
      const delivery = this.calculateDeliveryOnly(volume, product, duration, deliveryMethods);
      return {
        ...delivery,
        volume
      };
    } else {
      return {
        volume
      }
    }
  }

  private static getDeliveryPrice(duration: number, deliveryMethod: DeliveryMethod): number {
    console.log('Duration: ' + duration, deliveryMethod.pricePerHour, deliveryMethod.mapsMultiplicator, deliveryMethod.fillTime);
    return deliveryMethod.pricePerHour *
      (duration * deliveryMethod.mapsMultiplicator + deliveryMethod.fillTime)
  }
}
